import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_TASK } from "./actionTypes";
import { getTaskSuccess, getTaskError } from "./actions";

// Include call API
import { getTasksAPI } from "../../../api/tasks";

const tasksAPI = getTasksAPI();

function* getAllTasks({ payload: { user, size, page, status, rack, workstation, position, priorityMin, priorityMax } }) {
  try {
    const response = yield call(tasksAPI.getTasks, user.token, size, page, status, rack, workstation, position, priorityMin, priorityMax);
    yield put(getTaskSuccess(response.paginator, response.message));
  } catch (error) {
    yield put(getTaskError(error));
  }
}

export function* watchGetTasks() {
  yield takeEvery(GET_TASK, getAllTasks);
}

function* getTasksSaga() {
  yield all([fork(watchGetTasks)]);
}

export default getTasksSaga;
